export default __webpack_public_path__ + "static/media/educator-banner-en.c41db828.webp";